import 'zone.js';  // Included with Angular CLI.
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatDialogModule } from '@angular/material/dialog';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { isDevMode, importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { LazyLoaderModule } from '@dotglitch/ngx-common';

bootstrapApplication(AppComponent, {
    providers: [
        BrowserAnimationsModule,
        importProvidersFrom(
            CommonModule,
            BrowserModule,
            MatDialogModule,
            LazyLoaderModule.forRoot({
                entries: [],
            }),
            // ServiceWorkerModule.register('ngsw-worker.js', {
            //     enabled: !isTauriEnvironment && !isDevMode(),
            //     // Register the ServiceWorker as soon as the application is stable
            //     // or after 30 seconds (whichever comes first).
            //     registrationStrategy: 'registerWhenStable:30000'
            // })
        ),
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi())
    ]
})
  .catch(console.error);
